export default __webpack_public_path__ + "static/bubble_volunteer-0c234ed9bd3351518a1634dbc9353889.jpg";